import { useEffect, useState } from "react";
import { PortalLayout } from "@/components/layout/PortalLayout";
import { GlassCard } from "@/components/GlassCard";
import { StatusBadge } from "@/components/Badges";
import api from "@/lib/api";

export default function SystemHealth() {
  const [h, setH] = useState(null);
  useEffect(() => { api.get("/admin/system-health").then((r) => setH(r.data)); }, []);
  if (!h) return <PortalLayout title="System Health"><p className="text-sm text-muted-foreground">Loading…</p></PortalLayout>;
  return (
    <PortalLayout title="System Health">
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {Object.entries(h.services || {}).map(([k, v]) => (
          <GlassCard key={k} className="p-5">
            <div className="pdg-kicker capitalize">{k}</div>
            <div className="mt-3 flex items-center gap-2"><span className="w-2 h-2 rounded-full bg-[hsl(145_38%_62%)]" /><span className="text-sm text-foreground capitalize">{v}</span></div>
          </GlassCard>
        ))}
        <GlassCard className="p-5"><div className="pdg-kicker">Email queue</div><div className="mt-3 pdg-serif text-2xl text-foreground">{h.email_queue?.total ?? 0}</div><div className="text-xs text-muted-foreground mt-1">{h.email_queue?.failed ?? 0} failed &middot; {h.email_queue?.queue_stalled ? "stalled" : "healthy"}</div></GlassCard>
        <GlassCard className="p-5"><div className="pdg-kicker">Integration events</div><div className="mt-3 pdg-serif text-2xl text-foreground">{h.integration_events?.queued ?? 0}</div><div className="text-xs text-muted-foreground mt-1">{h.integration_events?.failed ?? 0} failed</div></GlassCard>
        <GlassCard className="p-5"><div className="pdg-kicker">Last inbound webhook</div><div className="mt-3 text-sm text-foreground">{h.last_inbound_webhook ? <StatusBadge status={h.last_inbound_webhook.status} /> : "None"}</div><div className="text-xs text-muted-foreground mt-2 pdg-mono">{h.last_inbound_webhook?.received_at ? new Date(h.last_inbound_webhook.received_at).toLocaleString() : "—"}</div></GlassCard>
      </div>

      <GlassCard className="p-6 mt-6">
        <h2 className="pdg-serif text-2xl text-foreground mb-4">Background agents</h2>
        <div className="space-y-2">
          {(h.agents || []).length === 0 && <p className="text-sm text-muted-foreground">No agent runs recorded yet.</p>}
          {(h.agents || []).map((a) => (
            <div key={a.id} className="flex items-center justify-between text-sm py-2 border-b border-border">
              <span className="text-foreground/85">{a.agent_name || a.agent}</span>
              <div className="flex items-center gap-3"><span className="text-xs text-muted-foreground">{a.duration_ms}ms</span><StatusBadge status={a.status} /></div>
            </div>
          ))}
        </div>
      </GlassCard>
    </PortalLayout>
  );
}
